import React, { Component } from 'react';
import kinopoisk from '../config/kinopoisk';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Button, Icon } from '@material-ui/core';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  }
});

class InputForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nickname: '',
      nicknameError: '',
      authorUrl: '',
      authorUrlError: '',
      startTyping: false,
      showAlert: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange = event => {
    this.setState({ startTyping: true });

    const name = event.target.name;
    const value = event.target.value.trim();
    this.setState({ [name]: value });

    if (name === 'authorUrl') {
      const value = event.target.value.trim();
      this.setState({ [name]: value });
      this.setState({ authorUrlError: this.constructUrlErrorMessage(value) });
    } else if (name === 'nickname') {
      const value = event.target.value;
      this.setState({ [name]: value });
      this.setState({
        nicknameError: this.constructNicknameErrorMessage(value)
      });
    }
  };

  isValidAuthorUrl = text => kinopoisk.authorUrlPattern.test(text);

  constructUrlErrorMessage = url => {
    if (!this.isValidAuthorUrl(url)) {
      return 'Неверный формат ссылки';
    } else if (this.props.authorWithUrlExists(url)) {
      return 'Автор с таким адресом уже добавлен';
    } else {
      return '';
    }
  };

  constructNicknameErrorMessage = nickname => {
    if (this.props.authorWithNicknameExists(nickname)) {
      return 'Автор с таким никнеймом уже добавлен';
    } else {
      return '';
    }
  };

  clearInputs = () => {
    this.setState({ nickname: '' });
    this.setState({ authorUrl: '' });
  };

  noInputErrors = () =>
    this.state.authorUrlError.length === 0 &&
    this.state.nicknameError.length === 0;

  handleSubmit = e => {
    e.preventDefault();
    if (this.noInputErrors() && this.state.startTyping) {
      this.props.addAuthor(this.state.nickname, this.state.authorUrl);
      this.clearInputs();
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <form
        id="input-form"
        className="card full-size"
        onSubmit={this.handleSubmit}
      >
        <h1>Новый автор</h1>
        <div>
          <TextField
            error={this.state.authorUrlError.length > 0}
            id="authorUrl-input"
            name="authorUrl"
            label="ссылка на КП-профиль"
            helperText={this.state.authorUrlError}
            type="text"
            autoComplete="off"
            margin="normal"
            variant="outlined"
            onChange={this.handleInputChange}
            value={this.state.authorUrl}
            fullWidth
          />
          <TextField
            error={this.state.nicknameError.length > 0}
            helperText={this.state.nicknameError}
            id="nickname-input"
            label="никнейм"
            type="text"
            autoComplete="off"
            name="nickname"
            margin="normal"
            variant="outlined"
            onChange={this.handleInputChange}
            value={this.state.nickname}
            fullWidth
          />
        </div>
        <div className="card-actions">
          <Button color="primary" variant="contained" type="submit">
            <Icon className={classes.leftIcon}>add_circle_outline</Icon>
            Добавить
          </Button>
        </div>
      </form>
    );
  }
}

export default withStyles(styles)(InputForm);



// WEBPACK FOOTER //
// ./src/components/InputForm.jsx